import { KwikspaceActions, KwikspaceActionTypes } from "../actions/kwikspace.action";

export interface KwikspaceState {
  provinces: any[];
  provincesLoading: boolean;
  provincesError: boolean;

  buildings: any[];
  buildingsLoading: boolean;
  buildingsError: boolean;

  organizations: any[];
  organizationsLoading: boolean;
  organizationsError: boolean;

  locations: any[];
  locationsLoading: boolean;
  locationsError: boolean;

  validities: any[];
  validitiesLoading: boolean;
  validitiesError: boolean;

  salesReps: any[];
  salesRepsLoading: boolean;
  salesRepsError: boolean;
}

export const initialState: KwikspaceState = {
  provinces: [],
  provincesLoading: false,
  provincesError: false,
  buildings: [],
  buildingsLoading: false,
  buildingsError: false,
  organizations: [],
  organizationsLoading: false,
  organizationsError: false,
  locations: [],
  locationsLoading: false,
  locationsError: false,
  validities: [],
  validitiesLoading: false,
  validitiesError: false,
  salesReps: [],
  salesRepsLoading: false,
  salesRepsError: false
};

export function reducer(
  state = initialState,
  action: KwikspaceActions
): KwikspaceState {
  switch (action.type) {
    case KwikspaceActionTypes.GET_PROVINCES: {
      return {
        ...state,
        provincesLoading: true,
        provincesError: false,
      };
    }

    case KwikspaceActionTypes.GET_PROVINCES_SUCCESS: {
      return {
        ...state,
        provinces: action.payload,
        provincesLoading: false,
        provincesError: false,
      };
    }

    case KwikspaceActionTypes.GET_PROVINCES_FAILURE: {
      return {
        ...state,
        provincesLoading: false,
        provincesError: true,
      };
    }

    case KwikspaceActionTypes.GET_BUILDINGS: {
      return {
        ...state,
        buildingsLoading: true,
        buildingsError: false,
      };
    }

    case KwikspaceActionTypes.GET_BUILDINGS_SUCCESS: {
      return {
        ...state,
        buildings: action.payload,
        buildingsLoading: false,
        buildingsError: false,
      };
    }

    case KwikspaceActionTypes.GET_BUILDINGS_FAILURE: {
      return {
        ...state,
        buildingsLoading: false,
        buildingsError: true,
      };
    }

    case KwikspaceActionTypes.GET_ORGANIZATIONS: {
      return {
        ...state,
        organizationsLoading: true,
        organizationsError: false,
      };
    }

    case KwikspaceActionTypes.GET_ORGANIZATIONS_SUCCESS: {
      return {
        ...state,
        organizations: action.payload,
        organizationsLoading: false,
        organizationsError: false,
      };
    }

    case KwikspaceActionTypes.GET_ORGANIZATIONS_FAILURE: {
      return {
        ...state,
        organizationsLoading: false,
        organizationsError: true,
      };
    }

    case KwikspaceActionTypes.GET_LOCATIONS: {
      return {
        ...state,
        locationsLoading: true,
        locationsError: false,
      };
    }

    case KwikspaceActionTypes.GET_LOCATIONS_SUCCESS: {
      return {
        ...state,
        locations: action.payload,
        locationsLoading: false,
        locationsError: false,
      };
    }

    case KwikspaceActionTypes.GET_LOCATIONS_FAILURE: {
      return {
        ...state,
        locationsLoading: false,
        locationsError: true,
      };
    }

    case KwikspaceActionTypes.GET_VALIDITIES: {
      return {
        ...state,
        validitiesLoading: true,
        validitiesError: false,
      };
    }

    case KwikspaceActionTypes.GET_VALIDITIES_SUCCESS: {
      return {
        ...state,
        validities: action.payload,
        validitiesLoading: false,
        validitiesError: false,
      };
    }

    case KwikspaceActionTypes.GET_VALIDITIES_FAILURE: {
      return {
        ...state,
        validitiesLoading: false,
        validitiesError: true,
      };
    }

    case KwikspaceActionTypes.GET_SALES_REPS: {
      return {
        ...state,
        salesRepsLoading: true,
        salesRepsError: false,
      };
    }

    case KwikspaceActionTypes.GET_SALES_REPS_SUCCESS: {
      return {
        ...state,
        salesReps: action.payload,
        salesRepsLoading: false,
        salesRepsError: false,
      };
    }

    case KwikspaceActionTypes.GET_SALES_REPS_FAILURE: {
      return {
        ...state,
        salesRepsLoading: false,
        salesRepsError: true,
      };
    }

    default:
      return state;
  }
}
